import { useState } from 'react'

import { useCopyToClipboard } from '../useCopyToClipboard'
import { useNotification } from '../useNotification'

import { COPIED_STATE_RESET_TIMEOUT } from './useCopyValue.constants'

export function useCopyValue({
  errorNotificationKey,
  successNotificationKey,
  value,
}) {
  const [copied, setCopied] = useState(false)

  const [, copy] = useCopyToClipboard({
    onError: handleErrorCopy,
    onSuccess: handleSuccessCopy,
  })

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  function handleSuccessCopy() {
    setCopied(true)

    handleAddSuccessNotification(successNotificationKey)

    setTimeout(() => {
      setCopied(false)
    }, COPIED_STATE_RESET_TIMEOUT)
  }

  function handleErrorCopy() {
    if (errorNotificationKey) {
      handleAddErrorNotification(errorNotificationKey)
    }
  }

  function handleCopy() {
    copy(value)
  }

  return { copied, handleCopy }
}
